import { LOGO_URL, NAV_LINKS, CONTACT } from "@/content";

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-white/10 py-12">
    <div className="mx-auto flex max-w-7xl flex-col gap-10 px-6 md:flex-row md:items-end md:justify-between">
      <div>
        <a href="#top" data-testid="footer-logo-link" className="flex items-center gap-3">
          <img
            src={LOGO_URL}
            alt="Desires After Hours flame logo"
            className="h-10 w-10 rounded-full object-cover ring-1 ring-white/20"
          />
          <span className="font-display text-sm font-bold uppercase tracking-[0.25em]">
            Desires After Hours
          </span>
        </a>
        <p className="mt-4 max-w-xs text-sm leading-relaxed text-zinc-500">
          The one-stop shop for all of your desires. Professional networking,
          curated after hours.
        </p>
      </div>

      <div className="flex flex-col gap-6 md:items-end">
        <nav className="flex gap-8">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`footer-${link.label.toLowerCase()}-link`}
              className="text-xs font-medium uppercase tracking-[0.2em] text-zinc-400 transition-colors duration-300 hover:text-white"
            >
              {link.label}
            </a>
          ))}
        </nav>
        <p className="text-xs text-zinc-600">
          © 2026 Desires After Hours · {CONTACT.email} ·{" "}
          <a
            href="/terms"
            data-testid="footer-terms-link"
            className="underline decoration-white/20 underline-offset-4 transition-colors duration-300 hover:text-white"
          >
            Terms & Policies
          </a>
        </p>
      </div>
    </div>
  </footer>
);
